import { useTranslation } from "react-i18next";
import { useSessionStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { useEffect, useMemo } from "react";
import { fetchDateien } from "./fetchDateien";

import { useState } from "react";
import Box from '@mui/material/Box';
import Layout from "../shared/components/LayoutComponent";
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import DownloadIcon from '@mui/icons-material/Download';
import Page from "../shared/components/PageComponent";
import { fetchFile } from "./fetchFile";
import openFile from "../shared/functions/download";
import { useMessage } from "../../context/message-context";
import { Divider, ListItemIcon, ListSubheader, Stack, TextField } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import { FullPageSpinner } from "../lib";

import { DateIsXMeasurementOld } from "../../functions/dates";

import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import ImageIcon from '@mui/icons-material/Image';
import ArticleIcon from '@mui/icons-material/Article';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { useSearchParams } from "react-router-dom";



function Personalmappe({ client }) {
  const { t } = useTranslation();
  const [accessToken,] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const [filesArray, setFilesArray] = useState([])
  const [workerInfo, setWorkerInfo] = useState()
  const [fileTypes, setFileTypes] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [filter1, setFilter1] = useState("")
  const [filter2, setFilter2] = useState(null)
  const { showErrorMessage } = useMessage();
  const [inputValue, setInputValue] = useState("")
  const [searchParams, setSearchParams] = useSearchParams();

  const userIdFuerMappe = useMemo(() => {
    if (searchParams && searchParams.get("userId")) {
      return searchParams.get("userId");
    } else {
      return null;
    }
  }, [searchParams]);


  useEffect(() => {
    if (client && userIdFuerMappe) {
      setIsLoading(true);
      fetchDateien(client, "PERSMM", accessToken, userIdFuerMappe)
        .then((data) => {
          setWorkerInfo(data.infos)
          setFilesArray(data.files)
          if (data.files && data.files.length > 0) {
            const fileTypes = []
            data.files.map((m) => {
              if (!fileTypes.includes(m.documentType)) fileTypes.push(m.documentType)
            })
            setFileTypes(fileTypes)
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setIsLoading(false);
        })
    } else {
      setIsLoading(true);
      fetchDateien(client, "PERSMA", accessToken)
        .then((data) => {
          setFilesArray(data.files)
          if (data.files && data.files.length > 0) {
            const fileTypes = []
            data.files.map((m) => {
              if (!fileTypes.includes(m.documentType)) fileTypes.push(m.documentType)
            })
            setFileTypes(fileTypes)
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setIsLoading(false);
        })
    }
  }, [client, userIdFuerMappe]);

  const handleDownload = (file) => {
    if (client) {
      let scriptProgram = ""
      let userId = ""
      if (!userIdFuerMappe) { scriptProgram = "PERSMA" }
      else {
        scriptProgram = "PERSMM"
        userId = userIdFuerMappe
      }
      setIsLoading(true);
      fetchFile(client, scriptProgram, accessToken, file.key, file.name + file.fileType, userId)
        .then((file) => {
          openFile(file.name, file.content);
        })
        .catch((err) => {
          showErrorMessage(err)
        })
        .finally(() => {
          setIsLoading(false);
        })
    }

  }

  const filteredArray = useMemo(() => {
    if (!filesArray || filesArray.length < 1) return []
    return filesArray.filter((m) => {
      const matchesFilter1 = m.name.toLowerCase().trim().includes(filter1.toLowerCase().trim());
      const matchesFilter2 = filter2 && filter2.trim() && m.documentType.toLowerCase().trim().includes(filter2.toLowerCase().trim());
      return matchesFilter1 && (filter2 ? matchesFilter2 : true);
    })
  }, [filesArray, filter1, filter2])



  const isOutsideOfTimeFrames = (date) => {
    return DateIsXMeasurementOld(date, "DD.MM.YYYY", "days") < 30
  }

  const isInTimeFrame1 = (date) => {
    return DateIsXMeasurementOld(date, "DD.MM.YYYY", "days") >= 30 &&
      DateIsXMeasurementOld(date, "DD.MM.YYYY", "months") < 6
  }

  const isInTimeFrame2 = (date) => {
    return DateIsXMeasurementOld(date, "DD.MM.YYYY", "months") >= 6 &&
      DateIsXMeasurementOld(date, "DD.MM.YYYY", "years") < 1
  }

  const isInTimeFrame3 = (date) => {
    return DateIsXMeasurementOld(date, "DD.MM.YYYY", "years") >= 1
  }

  const addFileIcon = (file) => {
    let Component = InsertDriveFileIcon
    let fileType = file.fileType.slice(1).toLowerCase()
    if (fileType === "pdf") Component = PictureAsPdfIcon
    if (["rtf", "doc", "docx", "txt"].includes(fileType)) Component = ArticleIcon
    if (["png", "jpg", "jpeg", "webp"].includes(fileType)) Component = ImageIcon
    if (["xls", "xlsx"].includes(fileType)) Component = TableChartIcon

    return <ListItemIcon>
      <Component />
    </ListItemIcon>
  }


  return (
    <>
      {isLoading && <FullPageSpinner />}
      <Page>
        <Layout>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container  >
              <Grid item xs={12} md={12} lg xl >
                <Typography sx={{ mt: 4 }} variant="h6" component="div">
                  {!userIdFuerMappe && t("Freigegebene Dateien")}
                  {userIdFuerMappe && workerInfo && t("Freigegebene Dateien von") + " " + workerInfo.nachname + ", " + workerInfo.vorname}
                </Typography>
                <List>
                  <Box p={2}>
                    <Stack spacing={2}>
                      <TextField
                        fullWidth
                        label={t("Suche")}
                        id="filter1"
                        variant="outlined"
                        value={filter1}
                        inputProps={{
                          autoCapitalize: "off",
                          autoCorrect: "off",
                          spellCheck: "false",
                          autoComplete: "off",
                        }}
                        onChange={(e) => setFilter1(e.target.value)}
                      />
                      {fileTypes && fileTypes.length > 0 &&
                        < Autocomplete
                          value={filter2}
                          onChange={(event, newValue) => {
                            setFilter2(newValue);
                          }}
                          inputValue={inputValue}
                          onInputChange={(event, newInputValue) => {
                            setInputValue(newInputValue);
                          }}
                          id="autocompleteTypeFilter"
                          options={fileTypes}
                          renderInput={(params) => <TextField {...params} label={t("Filter")} />}
                        />
                      }
                      {!fileTypes || (fileTypes && fileTypes.length < 1) && < Autocomplete
                        id="autocompleteDissabledTypeFilter"
                        disabled
                        options={fileTypes}
                        renderInput={(params) => <TextField {...params} label={t("Filter")} />}
                      />}
                    </Stack>
                  </Box>
                  {filteredArray && filteredArray.length > 0 && filteredArray.length <= 7 &&
                    <List >
                      {filteredArray.map((m, i) => {
                        return <div key={m.key}>
                          <ListItem
                            secondaryAction={
                              <IconButton onClick={() => { handleDownload(m) }} edge="end" aria-label="download">
                                <DownloadIcon />
                              </IconButton>
                            }>
                            {addFileIcon(m)}
                            <ListItemText
                              primary={m.name.slice(0, -11)}
                              secondary={m.date}
                            />
                          </ListItem>
                          {
                            filteredArray && filteredArray.length > 1 && (i + 1) < filteredArray.length &&
                            <Divider variant="middle" />
                          }
                        </div>
                      })}
                    </List>
                  }
                  {filteredArray && filteredArray.length > 7 &&
                    <List >
                      <List>
                        {filteredArray.filter((m) => isOutsideOfTimeFrames(m.date)).map((m, i) => {
                          return <div key={m.key}>
                            <ListItem
                              secondaryAction={
                                <IconButton onClick={() => { handleDownload(m) }} edge="end" aria-label="download">
                                  <DownloadIcon />
                                </IconButton>
                              }>
                              {addFileIcon(m)}
                              <ListItemText
                                primary={m.name.slice(0, -11)}
                                secondary={m.date}
                              />
                            </ListItem>
                            {
                              filteredArray && filteredArray.filter((m) => isOutsideOfTimeFrames(m.date)).length > 1 && (i + 1) < filteredArray.filter((m) => isOutsideOfTimeFrames(m.date)).length &&
                              <Divider variant="middle" />
                            }
                          </div>
                        })}
                      </List>
                      {filteredArray.filter((m) => isInTimeFrame1(m.date)).length > 0 && <List subheader={
                        <>
                          <Divider />
                          <ListSubheader component="div" id="olderThan30Days">{t("Älter als 30 Tage")}</ListSubheader>
                          <Divider />
                        </>
                      }>
                        {filteredArray.filter((m) => isInTimeFrame1(m.date)).map((m, i) => {
                          return <div key={m.key}>
                            <ListItem
                              secondaryAction={
                                <IconButton onClick={() => { handleDownload(m) }} edge="end" aria-label="download">
                                  <DownloadIcon />
                                </IconButton>
                              }>
                              {addFileIcon(m)}
                              <ListItemText
                                primary={m.name.slice(0, -11)}
                                secondary={m.date}
                              />
                            </ListItem>
                            {filteredArray && filteredArray.filter((m) => isInTimeFrame1(m.date)).length > 1 && (i + 1) < filteredArray.filter((m) => isInTimeFrame1(m.date)).length &&
                              <Divider variant="middle" />
                            }
                          </div>
                        })}
                      </List>}
                      {filteredArray.filter((m) => isInTimeFrame2(m.date)).length > 0 && <List subheader={
                        <>
                          <Divider />
                          <ListSubheader component="div" id="olderThan6Months">{t("Älter als 6 Monate")}</ListSubheader>
                          <Divider />
                        </>
                      }>
                        {filteredArray.filter((m) => isInTimeFrame2(m.date)).map((m, i) => {
                          return <div key={m.key}>

                            <ListItem
                              secondaryAction={
                                <IconButton onClick={() => { handleDownload(m) }} edge="end" aria-label="download">
                                  <DownloadIcon />
                                </IconButton>
                              }>
                              {addFileIcon(m)}
                              <ListItemText
                                primary={m.name.slice(0, -11)}
                                secondary={m.date}
                              />
                            </ListItem>
                            {filteredArray && filteredArray.filter((m) => isInTimeFrame2(m.date)).length > 1 && (i + 1) < filteredArray.filter((m) => isInTimeFrame2(m.date)).length &&
                              <Divider variant="middle" />
                            }
                          </div>
                        })}
                      </List>}
                      {filteredArray.filter((m) => isInTimeFrame3(m.date)).length > 0 && <List subheader={<>
                        <Divider />
                        <ListSubheader component="div" id="olderThan1Year">{t("Älter als 1 Jahr")}</ListSubheader>
                        <Divider />
                      </>
                      }>
                        {filteredArray.filter((m) => isInTimeFrame3(m.date)).map((m, i) => {
                          return <div key={m.key}>
                            <ListItem
                              secondaryAction={
                                <IconButton onClick={() => { handleDownload(m) }} edge="end" aria-label="download">
                                  <DownloadIcon />
                                </IconButton>
                              }>
                              {addFileIcon(m)}
                              <ListItemText
                                primary={m.name.slice(0, -11)}
                                secondary={m.date}
                              />
                            </ListItem>
                            {filteredArray && filteredArray.filter((m) => isInTimeFrame3(m.date)).length > 1 && (i + 1) < filteredArray.filter((m) => isInTimeFrame3(m.date)).length &&
                              <Divider variant="middle" />
                            }
                          </div>
                        })}
                      </List>}
                    </List>
                  }
                  {filteredArray && filteredArray.length < 1 && //empty selection
                    <>
                      <ListItem>
                        <ListItemText
                          primary={t("Es wurden keine freigegebenen Dokumente gefunden.")}
                        />
                      </ListItem>
                    </>
                  }
                </List>
              </Grid>
            </Grid>
          </Box>
        </Layout>
      </Page >
    </>
  )
}

export default Personalmappe; 